import { endOfDay, isValid, isWithinInterval, startOfDay } from 'date-fns';

import { TranscriptCategories } from '../model/transcript-categories.model';

/** @deprecated data is fetched when date range changes */
export function filterSummaryByDateRange(
    dateRange: { from: Date; to: Date } | null,
    categories: TranscriptCategories[],
): TranscriptCategories[] {
    if (
        dateRange == null ||
        !isValid(dateRange.from) ||
        !isValid(dateRange.to)
    ) {
        return [...categories];
    }

    const interval = {
        start: startOfDay(dateRange.from),
        end: endOfDay(dateRange.to),
    };

    return categories.map((c) => {
        const nextC = { ...c };

        nextC.subCategories = c.subCategories.map((sub) => {
            const nextSub = { ...sub };

            nextSub.transcripts = sub.transcripts.filter((t) => {
                return isWithinInterval(t.createdDateTime, interval);
            });

            return nextSub;
        });

        return nextC;
    });
}
